import { AU_COUNTRY_CODE } from '../constants'
import { formatNumberOnly } from './validators'

export default function formatPhoneNumber(phoneNumber: string): string {
  let formattedNumber = formatNumberOnly(phoneNumber)
  // TODO(swat-team): This is a hack to handle Australian phone numbers.
  // We will remove it once we implement international phone numbers.
  if (formattedNumber.length === 9) {
    formattedNumber = `0${  formattedNumber}`
  }
  // Add the country code so the backend handles it appropriately.
  if (formattedNumber.charAt(0) === '0') {
    formattedNumber = AU_COUNTRY_CODE + formattedNumber
  }
  return formattedNumber
}
